import React, { useContext } from "react";
import { Geojson } from "../Map/types";

interface IShapefileContext {
    scheme: Geojson;
}

const defaultState = {
    scheme: undefined
};

export const ShapefileContext = React.createContext<IShapefileContext>(defaultState);
export const useShapefileContext = () => useContext(ShapefileContext);
